module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "culturalhistory"
  }, [_c('div', {
    staticClass: "bannerbg",
    on: {
      "click": function($event) {
        return _vm.handlevideoAction()
      }
    }
  }, [_c('img', {
    staticClass: "bannerbg_pic",
    attrs: {
      "src": require("@/assets/images/mainindex/cultural.png")
    }
  }), _vm._v(" "), _c('div', [(false) ? _c('div', {
    staticClass: "bannerbg_desc"
  }, [_c('div', {
    staticClass: "bannerbg_desc_title"
  }, [_vm._v("啦啦操俱乐部")]), _vm._v(" "), _c('div', {
    staticClass: "bannerbg_desc_entitle"
  }, [_vm._v("CCA Club")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container_wrap"
  }, [_c('ColumnTitle', {
    attrs: {
      "title": "文化纪风采",
      "subtitle": "全面推进素质教育，提升学生综合素质，提高孩子参与体育运动积极性"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wenhuaji-img flex-start"
  }, [_c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1636097067736-7.jpeg?x-oss-process=style/tb-750",
      "alt": ""
    },
    on: {
      "click": _vm.onWhjDetail
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20210630/user-0/20210630/3e44554811dab30d506930d16a9b822e.jpg?x-oss-process=style/tb-750",
      "alt": ""
    },
    on: {
      "click": _vm.onWhjDetail
    }
  })]), _vm._v(" "), _c('ColumnTitle', {
    attrs: {
      "title": "大课间",
      "subtitle": "千万学生跳动啦啦操大课间"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wenhuaji-img flex-start"
  }, [_c('img', {
    staticStyle: {
      "width": "390px",
      "margin": "0 auto"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20210630/user-0/20210630/c69402490ed4b288c5bc02b5d92bcee2.jpeg?x-oss-process=style/tb-750",
      "alt": ""
    },
    on: {
      "click": _vm.onDkjDetail
    }
  })]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "bannerbg",
    on: {
      "click": function($event) {
        return _vm.handlevideoAction()
      }
    }
  }, [(!_vm.videoAction) ? _c('img', {
    staticClass: "bannerbg_pic",
    attrs: {
      "src": require("@/assets/images/mainindex/cultural-video@2x.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('video', {
    ref: "myVideo",
    attrs: {
      "preload": "auto",
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1599486954084-6.mp4",
      "controls": "controls"
    }
  }, [_vm._v("\n            您的浏览器不支持 video 标签。\n          ")]), _vm._v(" "), (!_vm.videoAction) ? _c('div', [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "banner_videoplay_icon",
    attrs: {
      "src": require("@/assets/images/mainindex/cultural-video-play@2x.png"),
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "tradeelite"
  }, [_c('div', {
    staticClass: "header_screen container_wrap"
  }, [_c('div', {
    staticClass: "header_screen_item"
  }, [_c('div', {
    staticClass: "header_screen_item_els"
  }, _vm._l((_vm.cateList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "header_screen_item_el",
      class: item.name === _vm.activeName ? 'header_screen_item_el_active' : '',
      on: {
        "click": function($event) {
          return _vm.onSelectType(item)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "star_list container_wrap"
  }, _vm._l((_vm.personList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "star_list_item_wrap",
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "star_list_item"
    }, [_c('div', {
      staticClass: "star_list_item_pic"
    }, [(item.pics.length > 0) ? _c('img', {
      attrs: {
        "src": item.pics[0].url,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_right"
    }, [_c('div', {
      staticClass: "star_list_item_right_name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_right_des"
    }, [_vm._v(_vm._s(item.desc))]), _vm._v(" "), _c('div', {
      staticClass: "star_list_item_right_star"
    }, [_vm._v(_vm._s(_vm.activeName))])])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "文化纪",
      "visible": _vm.centerDialogVisible,
      "width": "40%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/apply/wenhuaji.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("手机扫码进行报名")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "大课间",
      "visible": _vm.centerDialogVisible2,
      "width": "40%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/apply/wenhuaji.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("手机扫码进行报名")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible2 = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bannerbg_desc"
  }, [_c('div', {
    staticClass: "bannerbg_desc_title"
  }, [_vm._v("啦啦操俱乐部")]), _vm._v(" "), _c('div', {
    staticClass: "bannerbg_desc_entitle"
  }, [_vm._v("CCA Club")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0deb6219","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/CulturalHistory.vue
// module id = 1368
// module chunks = 0